"use client"

import { useRouter } from "next/navigation"

const IndexPage = () => {
  const router = useRouter()
  return router.replace("/dashboard/")
}

export default IndexPage
